import { useEffect, useRef, useState } from 'react';
const listeners = new Set();
export function emitToolEvent(event) {
    for (const listener of listeners){
        try {
            listener(event);
        } catch (error) {
            // Silently ignore listener errors to prevent one failing listener from affecting others
            console.debug('Tool event listener error:', error);
        }
    }
}
export function useToolEvents(filter) {
    const filterRef = useRef(filter);
    filterRef.current = filter;
    const [events, setEvents] = useState([]);
    useEffect(()=>{
        const handler = (ev)=>{
            if (filterRef.current(ev)) {
                setEvents((prev)=>{
                    // Keep all events - don't truncate the buffer
                    // For LCAT progress, we need to preserve all step completion states
                    // even if there are hundreds of progress updates
                    return [
                        ...prev,
                        ev
                    ];
                });
            }
        };
        listeners.add(handler);
        return ()=>{
            listeners.delete(handler);
        };
    }, []);
    const clear = ()=>setEvents([]);
    return {
        events,
        clear
    };
}
